import { useRecoilState, useRecoilValue } from "recoil";
import { authAtom } from "state/recoil-root";
import instance from "helpers/instance";
import { totalRow } from "state/roles-permissions";

import { vouchersAtom } from "state/vouchers";
import { listCommissionAtom } from "state/show";

const useCommissionExtraCostReport = () => {
  const [auth, setAuth] = useRecoilState(authAtom);
  const [vouchers, setVouchers] = useRecoilState(vouchersAtom);
  const [listCommission, setListCommission] = useRecoilState(listCommissionAtom);
    const [totalRows, setTotalRows] = useRecoilState(totalRow);
  const headers = {
    Authorization: `Bearer ${auth?.access_token}`,
  };
  return {
    getListCommissionExtra,
    exportCommissionExtra
  };


  function getListCommissionExtra(filter, page = 0, pageSize = 10) {
    let params = {
      ...filter,
    };
    if (page >= 0 && pageSize > 0) {
      const offset = page * pageSize;
      params = {
        offset,
        limit: pageSize,
        ...filter,
      };
    }
    return instance({
      url: "booking/v1/reports/commissions",
      method: "GET",
      headers,
      params,
    })
      .then((res) => {
        if (res.status === 200) {
          setListCommission(res.data.data);
          setTotalRows((preState) => ({
            ...preState,
            commission: res.data.meta.total,
          }));
          return res.data.data;
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  function exportCommissionExtra(filter, page = 0, pageSize = 10) {
    const offset = page * pageSize;
    const params = {
      ...filter,
      offset,
      limit: pageSize,
    };
    headers.responseType = "blob";
    return instance({
      url: "booking/v1/reports/commissions/export",
      method: "GET",
      params,
      responseType: "blob",
      headers,
    });
  }

  
}
export { useCommissionExtraCostReport };
